import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'titleCase'})
export class TitleCasePipe implements PipeTransform {
  public transform(value:string): string{
    if (!value) {
      return '';
    } else {
      return value.replace(/\w\S*/g, (txt => txt[0].toUpperCase() + txt.substr(1).toLowerCase() ));
    }
  }
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/pipes/titleCase.pipe.ts